import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Section } from '../ui/Section';
import { Card } from '../ui/Card';
import { reviews } from '../../data/mock';

export const ReviewsSlider = () => {
  return (
    <Section background="gray">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <h2 className="text-secondary font-bold uppercase tracking-widest mb-2 text-sm">Iskustva Klijenata</h2>
        <h3 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
          Šta Kažu <br />
          <span className="text-primary">Naši Zadovoljni Klijenti</span>
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.slice(0, 3).map((review) => (
          <Card key={review.id} className="p-8 relative bg-white border-none shadow-md">
            <Quote className="absolute top-6 right-6 text-primary/10" size={48} />
            
            <div className="flex gap-1 mb-4 text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} fill="currentColor" />
              ))}
            </div>

            <p className="text-gray-600 mb-6 italic leading-relaxed min-h-[80px]">
              "{review.comment}"
            </p>

            <div className="flex items-center gap-4 border-t border-gray-100 pt-4">
              <div className="w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center font-bold text-lg">
                {review.name.charAt(0)}
              </div>
              <div>
                <div className="font-bold text-gray-900">{review.name}</div>
                <div className="text-xs text-gray-500 flex items-center gap-1">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Google_Maps_icon.svg/1200px-Google_Maps_icon.svg.png" alt="Google" className="w-3 h-3" />
                  Google Recenzija
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </Section>
  );
};
